import type { Breadcrumb } from '~/type/Breadcrumb'

export function BreadcrumbsSerializer(el: { [ key: string ]: any } = {}): Breadcrumb {
  return {
    name: el.NAME,
    url: el.SECTION_PAGE_PATH,
  }
}
